import { render, staticRenderFns } from "./ASLDeductions.vue?vue&type=template&id=13534670&scoped=true"
import script from "./ASLDeductions.vue?vue&type=script&lang=js"
export * from "./ASLDeductions.vue?vue&type=script&lang=js"
import style0 from "./ASLDeductions.vue?vue&type=style&index=0&id=13534670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13534670",
  null
  
)

export default component.exports